import { render, staticRenderFns } from "./NotificationListItem.vue?vue&type=template&id=607290de&"
import script from "./NotificationListItem.vue?vue&type=script&lang=ts&"
export * from "./NotificationListItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports